import { query, where } from "firebase/firestore";
import { useState } from "react";
import { useEffectOnce } from "react-use";
import { getPropertyRolesLists } from "to-be-removed/api/utiles/userRights.utils";
import { LocalData } from "../../../to-be-removed/LocalData/General/LocalData";
import { CollectionData } from "../../../to-be-removed/LocalData/collections/CollectionData";

export const useGlobalCollections = () => {
  const [collections, setCollections] = useState<CollectionData[]>([]);

  useEffectOnce(() => {
    getAllGlobalCollections().then((collections) => {
      setCollections(collections);
    });
  });

  return collections;
};

export const getAllGlobalCollections = () => {
  const promises: Promise<CollectionData[]>[] = [];

  const propertyRolesLists = getPropertyRolesLists();
  promises.push(
    ...propertyRolesLists.map(
      (r) =>
        new Promise<CollectionData[]>((resolve) =>
          LocalData.collections.loadWithFilter(
            (ref) => query(ref, where("readAccess.propertyRoles", "array-contains-any", r)),
            (data) => {
              resolve(data);
            }
          )
        )
    )
  );

  return Promise.all(promises).then((data) => {
    const collections = [...new Set(data.flat())];
    return collections;
  });
};
